import Vue from 'vue';
import Vuex from 'vuex';
import MapModule from './map';
import SpotsModule from './spots';
import LangModule from './lang';
import System from './system';
import RouteModule from './route';

Vue.use(Vuex);

/**
 * アプリケーション全体のStore
 */
export default new Vuex.Store({
  modules: {
    map: MapModule,
    spots: SpotsModule,
    lang: LangModule,
    system: System,
    route: RouteModule,
  }
});
